import IconWrapper from "./../IconWrapper/IconWrapper";
import { FiltroStatusEmail } from "features/conta/typings";

interface FiltroEmailTagProps {
  setSelectedEmailStatus: (id?: FiltroStatusEmail) => any;
  selectedEmailStatus?: FiltroStatusEmail;
}
function FiltroEmailTag({
  selectedEmailStatus,
  setSelectedEmailStatus,
}: FiltroEmailTagProps) {
  const onSelectTipoStatus = (t?: FiltroStatusEmail) => {
    if (selectedEmailStatus === t) {
      setSelectedEmailStatus?.(undefined);
    } else {
      setSelectedEmailStatus?.(t);
    }
  };

  return (
    <>
      <IconWrapper
        onClick={() => onSelectTipoStatus?.()}
        selected={!selectedEmailStatus}
      >
        Todos
      </IconWrapper>

      <IconWrapper
        onClick={() => onSelectTipoStatus?.(FiltroStatusEmail.Enviados)}
        selected={selectedEmailStatus === FiltroStatusEmail.Enviados}
      >
        Enviados
      </IconWrapper>

      <IconWrapper
        onClick={() => onSelectTipoStatus?.(FiltroStatusEmail.NaoEnviados)}
        selected={selectedEmailStatus === FiltroStatusEmail.NaoEnviados}
      >
        Não enviados
      </IconWrapper>
    </>
  );
}

export default FiltroEmailTag;
